import React from 'react';
import { matchPath } from "@remix-run/react";
import { Link } from './Link';
import { colorSets } from './styles';
import { usePlayConfig } from '../../config/PlayConfigContext';
import { useRoutes } from '../../config/VideoAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlayLink = ({
  to,
  isInternal: isInternalValue,
  text,
  colorSet,
  ...rest
}) => {
  const routes = useRoutes();
  const config = usePlayConfig();
  const isInternal = isInternalValue || isInternalLink(routes, config.baseUrl, to);
  const linkProps = {
    isInternal,
    to,
    text,
    colorSet,
    ...rest
  };
  return /*#__PURE__*/_jsx(Link, {
    type: "text",
    ...linkProps
  });
};
export const PlayPrimaryLink = props => PlayLink({
  colorSet: colorSets.primary,
  ...props
});
export const PlaySecondaryLink = props => PlayLink({
  colorSet: colorSets.secondary,
  ...props
});
export const PlayAlertLink = props => PlayLink({
  colorSet: colorSets.alert,
  ...props
});
export const PlayTransparentLink = props => PlayLink({
  colorSet: colorSets.transparent,
  ...props
});
export const getPathWithoutBaseUrl = (path, baseUrl) => path.startsWith(baseUrl) ? path.split(baseUrl)[1] : path;
export const isInternalLink = (routes, baseUrl, to) => {
  if (to) {
    const path = to.split('?')[0];
    return routes.filter(route => route.pageId !== 'pageNotFound').some(route => {
      const pathWithoutBaseUrl = getPathWithoutBaseUrl(path, baseUrl);
      const match = matchPath(route, pathWithoutBaseUrl);
      return match !== undefined && match !== null;
    });
  }
  return false;
};